module.exports = __webpack_public_path__ + "static/media/S (67).43e56097.jpg";